import { BasePageFrame, type BasePageFrameProps } from "@/shared/layout";

/**
 * WithPrivatePage - Page container for authenticated/private routes
 *
 * Wraps all private pages with consistent full-width layout and spacing.
 * Uses BasePageFrame with "private" variant for unified styling.
 *
 * Applied at layout level in (private)/layout.tsx
 */

export interface WithPrivatePageProps
  extends Omit<BasePageFrameProps, "variant"> {}

export function WithPrivatePage({ children, ...props }: WithPrivatePageProps) {
  return (
    <BasePageFrame variant="private" {...props}>
      {children}
    </BasePageFrame>
  );
}
